import * as types from './types'
import { CountryCode } from '@carsys/enums/country-code'
import { Locales } from '@carsys/enums/locales'
import {
  GETAppointmentsResponse,
  GETCountriesResponse,
  GETDashboardResponse,
  GETSubsetResponse,
  GETWholesalerOrderInfoCsvResponse,
  GetGMSStatsCsvRequestParams,
  GetGMSStatsCsvResponse,
  GetWholesalerOrderInfoCsvRequestParams,
  StatisticsSubsetRequestParams,
  StatsticsRequestParams
} from '@cbgms/api'
import { AsyncAction } from '@cbgms/base/redux/async-action'
import * as requests from '@cbgms/api/modules/statistics/requests'

export const listDashboard = (params: StatsticsRequestParams) =>
  AsyncAction<GETDashboardResponse>({
    type: [types.GET_STATS, types.GET_STATS_SUCCESS, types.GET_STATS_FAILED],
    payload: {
      api: 'support',
      request: requests.getStatisticsDashboard(params)
    }
  })

export const listAppointments = (params: StatsticsRequestParams) =>
  AsyncAction<GETAppointmentsResponse>({
    type: [types.GET_APPOINTMENTS, types.GET_APPOINTMENTS_SUCCESS, types.GET_APPOINTMENTS_FAILED],
    payload: {
      api: 'support',
      request: requests.getStatisticsAppointments(params)
    }
  })

export const listSubset = (params: StatisticsSubsetRequestParams) =>
  AsyncAction<GETSubsetResponse>({
    type: [types.GET_SUBSET, types.GET_SUBSET_SUCCESS, types.GET_SUBSET_FAILED],
    payload: {
      api: 'support',
      request: requests.getStatisticsSubset(params)
    }
  })

export const getWholesalerOrderInfoCsv = (params: GetWholesalerOrderInfoCsvRequestParams) =>
  AsyncAction<GETWholesalerOrderInfoCsvResponse>({
    type: [types.GET_WHOLESALER_ORDER_INFO_CSV, types.GET_WHOLESALER_ORDER_INFO_CSV_SUCCESS, types.GET_WHOLESALER_ORDER_INFO_CSV_FAILED],
    payload: {
      api: 'support',
      request: requests.getWholesalerOrderInfoCsv(params)
    }
  })

export const getGMSStatsCsv = (params: GetGMSStatsCsvRequestParams) =>
  AsyncAction<GetGMSStatsCsvResponse>({
    type: [types.GET_GMS_STATISTICS_CSV, types.GET_GMS_STATISTICS_CSV_SUCCESS, types.GET_GMS_STATISTICS_CSV_FAILED],
    payload: {
      api: 'support',
      request: requests.getGMSStatsCsv(params)
    }
  })

export const getShopCountries = (locale?: Locales) =>
  AsyncAction<GETCountriesResponse>({
    type: [types.GET_SHOP_COUNTRIES, types.GET_SHOP_COUNTRIES_SUCCESS, types.GET_SHOP_COUNTRIES_FAILED],
    payload: {
      api: 'support',
      request: requests.getShopCountries(locale)
    }
  })

export const setShopID = (shopID: string) => ({
  type: types.SET_SHOP_ID,
  payload: {
    shopID
  }
})

export const setCompanyUUID = (companyUUID: string) => ({
  type: types.SET_COMPANY_UUID,
  payload: {
    companyUUID
  }
})

export const setFilteredByModule = (filteredByModule: string) => ({
  type: types.SET_FILTERED_BY_MODULE,
  payload: {
    filteredByModule
  }
})

export const setStartDate = (startDate: string) => ({
  type: types.SET_START_DATE,
  payload: {
    startDate
  }
})

export const setEndDate = (endDate: string) => ({
  type: types.SET_END_DATE,
  payload: {
    endDate
  }
})

export const setStatsCountry = (country: CountryCode | '') => ({
  type: types.SET_STATS_COUNTRY,
  payload: {
    country
  }
})
